module.exports = __webpack_public_path__ + "assets/img/CTA-cartoucherie-pdc1.bb113875.jpg";